import { render, staticRenderFns } from "./chateau-leoville-poyferre.vue?vue&type=template&id=5ba4dc2a&scoped=true"
import script from "./chateau-leoville-poyferre.vue?vue&type=script&lang=js"
export * from "./chateau-leoville-poyferre.vue?vue&type=script&lang=js"
import style0 from "./chateau-leoville-poyferre.vue?vue&type=style&index=0&id=5ba4dc2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba4dc2a",
  null
  
)

export default component.exports